import { Label } from 'redux/ducks/data/registrationPoints';

export type CreateLabel = Pick<Label, 'name'>;

export interface LabelsState {
  labels: Label[];
  loading: boolean;
}

export enum LabelActionTypes {
  LABELS_REQUEST = 'data/registrationPoints/LABELS_REQUEST',
  LABELS_FAILURE = 'data/registrationPoints/LABELS_FAILURE',
  FIND_LABELS_SUCCESS = 'data/registrationPoints/FIND_LABELS_SUCCESS',
  CREATE_LABEL_SUCCESS = 'data/registrationPoints/CREATE_LABEL_SUCCESS',
  UPDATE_LABEL_SUCCESS = 'data/registrationPoints/UPDATE_LABEL_SUCCESS',
  DELETE_LABEL_SUCCESS = 'data/registrationPoints/DELETE_LABEL_SUCCESS'
}

type LabelsRequestAction = {
  type: typeof LabelActionTypes.LABELS_REQUEST;
};

type LabelsFailureAction = {
  type: typeof LabelActionTypes.LABELS_FAILURE;
};

type FindLabelsSuccessAction = {
  type: typeof LabelActionTypes.FIND_LABELS_SUCCESS;
  payload: Label[];
};

type CreateLabelSuccessAction = {
  type: typeof LabelActionTypes.CREATE_LABEL_SUCCESS;
  payload: Label;
};

type UpdateLabelSuccessAction = {
  type: typeof LabelActionTypes.UPDATE_LABEL_SUCCESS;
  payload: Label;
};

type DeleteLabelSuccessAction = {
  type: typeof LabelActionTypes.DELETE_LABEL_SUCCESS;
  payload: Label;
};

export type LabelActions =
  | LabelsRequestAction
  | LabelsFailureAction
  | FindLabelsSuccessAction
  | CreateLabelSuccessAction
  | UpdateLabelSuccessAction
  | DeleteLabelSuccessAction;
